export const DEALER_TAKE = 50;

export const ALL_DEALERS_TAKE = 50;

export const DEFAULT_DISTANCE = 50;
